$shm_hitalama_map_page $shm_hitalama_entity_page
	widget_props_tab? \general
	widget_props_open*? null
	Widget_props $shm_hitalama_map_widget_page
	map $shm_hitalama_map
		slideshow_enabled? => slideshow_enabled?
		camera_locked => camera_locked
		interaction_locked => interaction_locked
		backup_time => backup_time
		slideshow_frame? => slideshow_frame?
		slideshow_frame_str => slideshow_frame_str
		viewport_frames_visible => viewport_frames_visible
	cut_title \Удалить карту
	overlayed false
	auto /
		<= selection_cleanup null
		<= interaction_lock_auto null
		<= keyboard_move_auto
		<= keydown_listener $shm_listener /
			\keydown
			<= keydown_handler null
		<= keydown_listener_nopassive $shm_listener /
			\keydown
			<= keydown_handler_nopassive null
			<= document null
			* passive false
		<= paste_listener $shm_listener /
			\paste
			<= paste_handler null
		<= history_pointercancel_listener $shm_listener /
			\pointercancel
			<= history_pointer_end null
			<= document null
		<= history_blur_listener $shm_listener /
			\blur
			<= history_pointer_end null
			<= window null
		<= resize_listener $shm_listener /
			\resize
			<= resize_handler null
			<= window null
		<= pull_drags_synced null
		<= hovered_link? null
		- <= send_presence_pos_atom null
		<= viewport_to_frame? null
		<= autobackup? null
		<= stickable?
		<= Dragger_set_pos null
		<= journal_benchmark_auto null
	selected_links? /$giper_baza_link
	selected_links_raw? /$giper_baza_link
	selectbox_dragged? false
	go_to_frame_by_num* null
	go_to_widget* null
	set_frame* null
	some_transforming false
	widgets_filtered /$shm_hitalama_map_widget
	layout_drop_candidates /
	layout_drop_best null
	layout_drag_preview null
	layout_drag_commit null
	sub /
		<= Pane
	widgets_source /$shm_hitalama_map_widget
	history_showed? false
	widget_to_top* null
	widget_to_bottom* null
	widget_z*? 0
	widget_headers_visible false
	stickable false
	selected*? false
	hovered*? false
	hover_styled* false
	sticks_x* /number
	sticks_y* /number
	drags_synced* /$rise_drag
	widget_event_contextmenu*? null
	contextmenu_body? /
	get_pointer_pos /
	get_center_pos /
	contextmenu_pos? /
		0
		0
	contextmenu_real_pos /
	arrows_visible true
	tool_mode? \
	widget_tools_hidden false
	multi_select_enabled? false
	Keyboard_move $shm_hitalama_map_page_keyboard_move
		Map_page <= Map_page
		auto => keyboard_move_auto
	Back_contextmenu_body $shm_hitalama_map_page_contextmenu
		Map_page <= Map_page $shm_hitalama_map_page
		map <= map
		contextmenu_real_pos <= contextmenu_real_pos
		contextmenu_showed? <=> contextmenu_showed? false
	Arrows $shm_hitalama_map_page_arrows
		Map_page <= Map_page
		visible <= arrows_visible
		widget_arrows => widget_arrows
	deselect_all null
	Pane $shm_hitalama_map_pane
		event *
			^
			focusin? <=> history_edit_start? null
			focusout? <=> history_edit_end? null
		Map_page <= Map_page
		box_in_viewport? => box_in_viewport?
		event_drop? <=> event_drop? null
		select_start? => select_start?
		select_rect_pos => select_rect_pos
		select_rect_size => select_rect_size
		select_resize <= select_resize null
		zoom? => zoom?
		shift? => shift?
		pointer_pos => pointer_pos
		real_pointer_pos => real_pointer_pos
		to_real_pos* => to_real_pos*
		client_pos_to_pane_pos* => client_pos_to_pane_pos*
		back_event_pointerdown? <=> back_event_pointerdown? null
		back_event_contextmenu? <=> back_event_contextmenu? null
		prevent_shift_x <= prevent_shift_x false
		prevent_shift_y <= prevent_shift_y false
		touch_event_disabled <= touch_event_disabled false
		tool_mode <= interaction_tool_mode \
		outside /
			^ contextmenu_visible /
				<= Context_menu $shm_hitalama_contextmenu
					body <= contextmenu_body
					pos? <=> contextmenu_pos_shifted? /
					showed? <=> contextmenu_showed? false
			<= Statistics $shm_hitalama_map_statistics
				map <= map
				widgets <= widgets_source
		body /
			^ widget_arrows
			^ widgets_view /
				<= Widget* $shm_hitalama_map_widget_any
					Map_page <= Map_page $shm_hitalama_map_page
					widget <= widget_by_link* $shm_hitalama_map_widget
			^ notebook2_adds /
			^ selectbox_view /
				<= Selectbox $shm_hitalama_map_selectbox
					Map_page <= Map_page
					selected_links <= selected_links
					zoom <= zoom
			^ cursors /
				<= Cursor* $shm_hitalama_map_presence_cursor
					pos <= presence_pos* null
			^ dragger /
				<= Dragger $shm_hitalama_map_page_dragger
					Map_page <= Map_page
	event *
		pointerdown? <=> event_pointerdown? null
		resize? <=> event_resize? null
	style *
		^
		--shm_hitalama_map_widget_float_resizer_size <= widget_float_resizer_size_css \15px
